import Client from "./Clients/AxiosClient";
var resource = "/api";

export default {
  createFamilyAccount(familyAccount) {
    return Client.post(
      `${resource}/FamilyAccount`,
      familyAccount,
      {
        withCredentials: true,
        responseType: "json",
        headers: { "Content-Type": "application/json" }
      }
    );
  },
  getFamilyAccounts(userId) {
    return Client.get(`${resource}/FamilyAccount/` + userId, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
};
